import { render, staticRenderFns } from "./SingleItemSetComponent.vue?vue&type=template&id=50853e2a"
import script from "./SingleItemSetComponent.vue?vue&type=script&lang=js"
export * from "./SingleItemSetComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports